import { ExpertTipsDTO, SportName } from '@the-game/api-interfaces'
import { useQuery } from 'react-query'
import { environment } from '../../environments/environment'
import { useAuthenticatedFetch } from './useAuthenticatedFetch'

export function useExpertTipsNextRound(
    sport: SportName,
    season: string,
    round?: number,
    totalRounds?: number,
) {
    const authenticatedFetch = useAuthenticatedFetch()

    return useQuery(
        ['expertTipsNextRound', sport, season, round],
        async () => {
            const response = await authenticatedFetch(
                `${
                    environment.apiGatewayUrl
                }/expert-tips/sport/${sport}/season/${season}/round/${
                    round ? round + 1 : round
                }`,
            )

            if (response.status !== 200) {
                throw new Error('Error fetching upcoming Expert Tips data')
            }

            return response.json() as Promise<ExpertTipsDTO>
        },
        {
            enabled: round && totalRounds && round + 1 <= totalRounds,
        },
    )
}
